<!--Header-->
<div class="flex-header">
  <b class="modal-headerTitle" *ngIf="!editFavorites">Favorites</b>
  <b class="modal-headerTitle" *ngIf="editFavorites">Edit Favorites</b>
</div>
<!--Body-->
<div class="flex-content">
    <menu #menu favoritesCheckbox="true"
    menuIdentifier="favorites"
    (portalCheckboxEvent)="portalCheckboxClick($event)"
		[favoritesDefaults]="isDefaultPreferences"></menu>
</div>